import React, { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

type AppProviderContextsType = { children: ReactNode };

export default function AppProviderContexts({ children }: AppProviderContextsType) {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
